import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSticker } from '../context/StickerContext';
import { LeftToolRail, ToolType } from '../components/editor/LeftToolRail';
import { CanvasToolbar } from '../components/editor/CanvasToolbar';
import { EditorCanvas } from '../components/editor/EditorCanvas';
import { CutlinePanel } from '../components/editor/CutlinePanel';
import { SizePanel } from '../components/editor/SizePanel';
import { QRCodePanel } from '../components/editor/QRCodePanel';
import { QuantityPanel } from '../components/editor/QuantityPanel';
import { FiltersPanel } from '../components/editor/FiltersPanel';
import { TextPanel } from '../components/editor/TextPanel';
import { ClipartPanel } from '../components/editor/ClipartPanel';
import { PrimaryButtonGreen, SecondaryButtonOutline } from '../components/ui/Buttons';
import { Share2 } from 'lucide-react';
export function EditorPage() {
  const navigate = useNavigate();
  const {
    totalPrice,
    pricePerSticker,
    quantity
  } = useSticker();
  const [activeTool, setActiveTool] = useState<ToolType>('cutline');
  const renderActivePanel = () => {
    switch (activeTool) {
      case 'cutline':
        return <CutlinePanel data-id="element-286" />;
      case 'size':
        return <SizePanel data-id="element-287" />;
      case 'qrcode':
        return <QRCodePanel data-id="element-288" />;
      case 'quantity':
        return <QuantityPanel data-id="element-289" />;
      case 'filters':
        return <FiltersPanel data-id="element-290" />;
      case 'text':
        return <TextPanel data-id="element-291" />;
      case 'clipart':
        return <ClipartPanel data-id="element-292" />;
      default:
        return <CutlinePanel data-id="element-293" />;
    }
  };
  return <div className="h-screen flex flex-col bg-white overflow-hidden" data-id="element-294">
      {/* Editor Header */}
      <header className="h-14 border-b border-gray-200 flex items-center justify-between px-4 bg-white z-30" data-id="element-295">
        <div className="flex items-center gap-4" data-id="element-296">
          <span className="font-bold text-gray-900 tracking-tight" data-id="element-297">
            Stick Your Logo Here
          </span>
          <div className="h-4 w-px bg-gray-300" data-id="element-298" />
          <span className="text-sm font-medium text-gray-700" data-id="element-299">
            Design 1 · Die cut sticker
          </span>
        </div>

        <div className="flex items-center gap-4" data-id="element-300">
          <div className="text-right hidden md:block" data-id="element-301">
            <span className="text-xs text-gray-500 block" data-id="element-302">
              {quantity} · ${pricePerSticker}
            </span>
            <span className="text-sm font-bold text-gray-900" data-id="element-303">
              $
              {totalPrice.toLocaleString('en-US', {
              minimumFractionDigits: 2
            })}
            </span>
          </div>
          <SecondaryButtonOutline className="!py-1.5 !px-3 text-sm flex items-center gap-2" data-id="element-304">
            <Share2 size={14} data-id="element-305" />
            Share
          </SecondaryButtonOutline>
          <PrimaryButtonGreen className="!py-1.5 !px-4 text-sm" onClick={() => navigate('/stickers/order-summary')} data-id="element-306">
            Confirm
          </PrimaryButtonGreen>
        </div>
      </header>

      {/* Main Workspace */}
      <div className="flex-1 flex overflow-hidden" data-id="element-307">
        {/* Left Rail */}
        <LeftToolRail activeTool={activeTool} onToolChange={setActiveTool} data-id="element-308" />

        {/* Tool Panel */}
        <div className="w-80 bg-white border-r border-gray-200 h-full z-10 shadow-[4px_0_24px_rgba(0,0,0,0.02)]" data-id="element-309">
          {renderActivePanel()}
        </div>

        {/* Canvas Area */}
        <div className="flex-1 flex flex-col relative bg-gray-100" data-id="element-310">
          {/* Top Toolbar Layer */}
          <div className="absolute top-4 right-4 z-20 flex items-center gap-4" data-id="element-311">
            <div className="flex gap-4 text-sm font-medium text-violet-600" data-id="element-312">
              <button className="hover:text-violet-700" data-id="element-313">Add Note</button>
              <button className="hover:text-violet-700" data-id="element-314">Settings</button>
            </div>
            <CanvasToolbar data-id="element-315" />
          </div>

          <EditorCanvas data-id="element-316" />
        </div>
      </div>
    </div>;
}